import Rollbar from 'rollbar';
import config from '../../rollbar.config';

export const rollbar = new Rollbar(config);

export default {
  install(app) {
    app.config.errorHandler = (error, vm, info) => {
      rollbar.error(error, {
        vueComponent: vm?.$options?.name || 'Anonymous Component',
        info: info,
      });

      if (process.env.NODE_ENV === 'development') {
        console.error(error);
      }
    };

    app.provide('rollbar', rollbar);
    app.config.globalProperties.$rollbar = rollbar;
  },
};
